import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../../../views/types';
import type { SectionsPropsType } from '../../../../sections/types';
import { renderAdvisorMessage } from '../../../../views/AdvisorMessage';
import { renderUserMessage } from '../../../../views/UserMessage';
import { renderSimpleButtonGroup } from '../../../../views/SimpleButtonGroup';
import { renderSingleImage } from '../../../../views/SingleImage';
import { buildAnswers, buildUserAnswerMessage } from '../../../../sections/utils';

import TileRoofFadingExamplePngPath from 'Images/me/pages/guest/proposals/new/tile_roof_fading/example.png'
import TileRoofFadingExampleWebPPath from 'Images/me/pages/guest/proposals/new/tile_roof_fading/example.webp'

const SECTION_KEY_NAME = 'tileRoofFading';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'roofKawaraFading';

export const tileRoofFadingSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: '全体的にみられます', textContents: (<>全体的に<br />みられる</>) },
    { value: '所々みられます', textContents: (<>所々<br />みられる</>) },
    { value: 'まったくない', textContents: (<>まったく<br />ない</>) },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '瓦屋根_瓦の色あせはあるか',
      answer: textContent || '',
      value: value || '',
    });
  };

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        屋根の劣化状況についてお伺いします。
      </>
    ),
  });

  // アドバイザーの吹き出し
  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    imagePaths: {
      imagePath: TileRoofFadingExamplePngPath,
      webp: TileRoofFadingExampleWebPPath,
    },
    altText: '瓦の色あせ',
    viewWidth: {
      pc: 350,
      mobile: 320,
    },
    imageRatio: { width: 350, height: 222 },
    withWebp: true,
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        新築のころと比べて、瓦の色がくすんでいませんか？<br />
        瓦の色あせは、経年劣化の証拠です。
      </>
    ),
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        瓦に色あせはみられますか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.value),
  });

  // 回答内容を返却する
  return answer;
};
